export const SPIM_COMPLETE = 0;
export const SPIM_MISSING_FILE = 1;
export const SPIM_UNAVAILABLE = 2;